import { render } from "./UserSelectionCard.vue?vue&type=template&id=0ec0a0b2&scoped=true"
import script from "./UserSelectionCard.vue?vue&type=script&lang=js"
export * from "./UserSelectionCard.vue?vue&type=script&lang=js"

import "./UserSelectionCard.vue?vue&type=style&index=0&id=0ec0a0b2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec0a0b2"]])

export default __exports__